import { Box, type SxProps, type Theme } from '@mui/material';
import { RhfFractionField } from '@core/components';
import type { CustomerMeasurementFormValues } from '../hooks/useCustomerForm';

const MEASUREMENT_FIELDS = {
  alb: [
    ['length', 'Length (in)'],
    ['shoulder', 'Shoulder (in)'],
    ['sleeve', 'Sleeve (in)'],
    ['neck', 'Neck (in)'],
    ['chest', 'Chest (in)'],
    ['waist', 'Waist (in)'],
    ['figure', 'Figure (in)'],
  ],
  chasuble: [
    ['chasubleLength', 'Length (in)'],
    ['chasubleSleeve', 'Sleeve (in)'],
  ],
  mitre: [['head', 'Head (in)']],
} as const satisfies Record<
  string,
  readonly (readonly [keyof CustomerMeasurementFormValues, string])[]
>;

export function CustomerMeasurementFields({
  group,
  columns,
  sx,
}: {
  group: keyof typeof MEASUREMENT_FIELDS;
  columns: string | { xs: string; md: string };
  sx?: SxProps<Theme>;
}) {
  return (
    <Box
      sx={[
        {
          display: 'grid',
          gridTemplateColumns: columns,
          gap: 2,
        },
        ...(sx == null ? [] : Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {MEASUREMENT_FIELDS[group].map(([name, label]) => (
        <RhfFractionField<CustomerMeasurementFormValues>
          key={name}
          name={name}
          label={label}
        />
      ))}
    </Box>
  );
}
